<template>
    <label class="block font-semibold text-black-700">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot /></span>
    </label>
</template>

<script>
export default {
    props: ['value'],
};
</script>
